import { render } from "./HistoryGetFriend.vue?vue&type=template&id=3926dff3&scoped=true"
import script from "./HistoryGetFriend.vue?vue&type=script&lang=js"
export * from "./HistoryGetFriend.vue?vue&type=script&lang=js"

import "./HistoryGetFriend.vue?vue&type=style&index=0&id=3926dff3&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/vue-code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3926dff3"]])

export default __exports__